import { Box } from "@repo/components/src/ui/box";
import { Heading } from "@repo/components/src/ui/heading";
import { HStack } from "@repo/components/src/ui/hstack";
import React from "react";

type Props = {
  actionButton?: React.ReactNode;
  title: string;
};

const ProfileHeader = React.memo((props: Props) => {
  const { actionButton, title } = props;
  return (
    <>
      <HStack className="justify-between items-center pt-2">
        <Heading>{title}</Heading>
        {actionButton}
      </HStack>
      <Box className="border-t border-outline-100 mt-2 mb-3 w-full" />
    </>
  );
});

ProfileHeader.displayName = "ProfileHeader";

export default ProfileHeader;
